import classNames from "classnames";
import React from "react";

interface Props extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  title?: React.ReactNode | React.ReactNode[];
  content?: React.ReactNode;
  image?: string | React.ReactNode;
}

/**
 * 居中于本身宽度高度的通用的空状态组件, 包括一个图 + 一个标题 + 一段文字
 * 宽度默认为 100%
 * 高度默认为内容撑起, 一般需要用className或者style给Empty一个容器高度比如h-[calc(100vh-56px)]
 * @example src/components/ErrorBoundary/ErrorUi.tsx
 */
const Empty = ({ title, content, className, image, ...divProps }: Props) => {
  const renderImage = () => {
    if (typeof image === "string") {
      return (
        <img
          src={image}
          className="pointer-events-none h-[146px] select-none"
        />
      );
    }

    if (image === undefined) {
      return (
        <img
          src="https://pfile.pddpic.com/galerie-go/sms/empty.png.slim.png"
          className="pointer-events-none h-[146px] select-none"
        />
      );
    }

    return image;
  };

  return (
    <div
      className={classNames(
        "flex flex-col items-center justify-center",
        className
      )}
      {...divProps}
    >
      {renderImage()}
      <div className="mt-6 text-lg font-semibold">{title}</div>
      <div className="mt-2 flex max-w-[480px] flex-col items-center gap-1 text-center text-sm text-text-black/[.65]">
        {Array.isArray(content)
          ? content.map((item, index) => <div key={index}>{item}</div>)
          : content}
      </div>
    </div>
  );
};

export default Empty;
